import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontLeftShockAbsorberProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function FrontLeftShockAbsorber(props: FrontLeftShockAbsorberProps) {
  return (
    <svg
      width="70"
      height="30"
      viewBox="0 0 70 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{bottom: 124, left: 247}}
      onClick={props.onClick}
    >
      <path
        d="M35.0002 25C38.2719 25 41.1768 23.429 43.0012 21H63.0002C66.3139 21 69.0002 18.3137 69.0002 15C69.0002 11.6863 66.3139 9 63.0002 9H43.0012C41.1768 6.57104 38.2719 5 35.0002 5C31.7285 5 28.8236 6.57104 26.9992 9H7.00018C3.68647 9 1.00018 11.6863 1.00018 15C1.00018 18.3137 3.68647 21 7.00018 21H26.9992C28.8236 23.429 31.7285 25 35.0002 25Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <circle
        cx="4"
        cy="4"
        r="4"
        transform="matrix(1 0 0 -1 31.0002 19)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="matrix(1 0 0 -1 61.0002 17)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="matrix(1 0 0 -1 5.00018 17)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M27.0002 21H7.00018C3.68647 21 1.00018 18.3137 1.00018 15C1.00018 11.6863 3.68647 9 7.00018 9H27.0002"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M43.0002 21L63.0002 21C66.3139 21 69.0002 18.3137 69.0002 15C69.0002 11.6863 66.3139 9 63.0002 9H43.0002"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="10"
        cy="10"
        r="10"
        transform="matrix(1 0 0 -1 25.0002 25)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M22 20.8308C24.3086 25.6607 29.2619 29 35 29C40.7381 29 45.6914 25.6607 48 20.8308M22 8.57711C23.734 4.9493 26.9601 2.16248 30.8901 0.999999M48 8.57711C46.266 4.9493 43.0399 2.16248 39.1099 0.999999"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
